var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9595 20.2959C19.5766 26.4216 12.1798 52.8792 25.4186 70.2418L31.978 65.3873C17.4446 46.4166 36.6956 19.662 59.1629 29.7279C73.2692 36.0437 76.7057 53.5498 67.217 65.4174C68.8351 66.2782 71.551 69.0374 72.9489 69.6646C73.3727 69.8548 73.6863 70.0283 74.1033 69.6813C92.5269 45.9695 70.2031 11.9216 40.9595 20.2959Z",
    fill: "#285171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5965 70.8589C57.8684 64.8601 69.9461 58.948 65.492 45.4256C60.0437 28.8871 34.587 31.366 33.189 49.2324C32.8821 53.1427 34.6871 59.3217 37.9 61.6838L43.9556 57.6868C33.4092 47.7377 49.9811 34.5756 57.4213 45.7726C61.3616 51.7047 56.9242 56.4991 52.3533 59.8989C45.4403 65.0369 37.3462 68.9038 30.4365 74.1153C30.1663 74.5123 36.2218 78.3425 37.1293 78.2791C40.2355 76.2372 43.285 74.1086 46.4245 72.1168C46.8216 71.8632 47.9726 71.2626 48.5932 70.8623",
    fill: "#285171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8899 80.5713C45.7674 80.9216 50.2181 81.6356 56.0301 80.578C60.4342 79.7772 64.1009 78.099 68.9086 74.7226L62.7063 69.1575L44.8932 80.5713H44.8899Z",
    fill: "#285171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.245b9fab337395d43a2fb10e987a3b87.svg";
export { ForwardRef as ReactComponent };